import * as React from "react";

class InfoDialogAContent extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <>
        <section>
          <div className="title">
            <h2>沒關係，每個人都有怕怕病毒的！</h2>
            <h3>什麼是怕怕病毒呢？怕怕病毒便是「恐懼」的化身</h3>
          </div>
          <p>那恐懼又是什麼呢？</p>
          <p>
            恐懼是人與生俱來的情緒，更是大部分情緒的源頭。一般而言，恐懼是面對危險時為了生存而進行防禦或逃跑的本能行為，而幾乎所有頭腦的活動都可以解釋為對「生存」的恐懼。
          </p>
          <p>
            因此人在感到恐懼後的生理反應是：
            <br />
            1.腎上腺素大量釋放，心跳加快、血壓上升、呼吸加深加快
            <br />
            2.肌肉緊繃而供血量增大，以供逃跑或抵抗
            <br />
            3.瞳孔擴大以接收更多光線
            <br />
            4.大腦釋放多巴胺類物質，精神高度集中，以供迅速判斷形勢
          </p>
          <p>
            以上是我們面對有形的恐懼時的生理反應，但其實有些恐懼是無形的、長期深埋在我們心中，使得我們生活中總顯得莫名焦慮、焦躁！
          </p>
        </section>
        <section>
          <div className="title">
            <h2>勇敢是駕馭恐懼，而不是沒有恐懼</h2>
          </div>
          <p>
            不用擔心，每個人都有怕怕病毒，這是正常的。你可以和你的怕怕病毒和平相處，就可以降低「怕怕病毒」影響你生活的程度。
          </p>
          <p>
            2014年12月的美國《科學人》雜誌曾詳細報導哈佛大學科學家的研究成果：恐懼反應是可以被改善的。所以就像兔兔村長所說：「只要你真心想改變，就可以做到！」
          </p>
        </section>
        <section>
          <div className="title">
            <h2>為什麼要把害怕的東西想像成是朋友呢？</h2>
          </div>
          <p>
            過度災難式的想像會加深恐懼的程度！別再用會讓你動彈不得的想法餵養自己的恐懼。否認、壓抑或隱藏恐懼也可能讓"怕怕病毒”在你毫無防備時冒出來嚇壞你。因此，我們可以用正面的方式運用想像力，承認自己的恐懼，並且去處理它。
          </p>
          <p>
            試著轉換恐懼的樣貌，讓它不再讓你感到難受，就像是有些人會在演講時將台下的人想像成是紅蘿蔔，舒緩緊張和降低自己的恐懼情緒。
          </p>
          <p>
            轉換的過程中，你可以去思考自己到底在害怕什麼，為什麼會害怕，在這個過程中整理思緒，讓自己平靜下來。
          </p>
        </section>
        <section>
          <div className="title">
            <h2>學習表達情緒</h2>
          </div>
          <p>
            學習把情緒表達出來，不再壓抑，也能讓緊繃的身心稍微獲得解放，表達出來的同時也能整理自己的思緒，讓想像力到此為止，停止不好的想像。
          </p>
          <p>
            不一定要透過話語說出來，「說出來」只是心理諮商的一種手段方法。像是藝術治療，你也可以試著透過音樂、舞蹈和畫圖等將自己的情緒表達出來。就像是Eason除了說出來以外，也試著畫下來。
          </p>
          <p>
            但如果是你身邊的朋友正為恐懼感到困擾時，先不要強迫他，在那之前，先讓他知道你願意陪伴他、聆聽他的聲音，並且不會給他任何負面或過於正面的評價。當你能不帶任何預設地傾聽，才能了解他真的感覺是什麼。
          </p>
        </section>
      </>
    );
  }
}

export default InfoDialogAContent;



// WEBPACK FOOTER //
// ./src/infoDialogA/components/InfoDialogAContent.tsx